<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h600_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditForm"
          :model="dialogAddEditForm"
          :rules="dialogAddEditFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div
              class="modal-row-box"
              style="padding-bottom:10px"
            >
              <el-row :gutter="10">
                <!-- <el-col :span="12">
                  <el-form-item
                    label="政策名称"
                    prop="policyName"
                  >
                    <el-input v-model="dialogAddEditForm.policyName" />
                  </el-form-item>
                </el-col> -->
                <el-col :span="6">
                  <el-form-item
                    label="省区"
                    prop="provinceId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.provinceId"
                      filterable
                      clearable
                      placeholder="请选择省区"
                      style="width:100%"
                      @change="changeProvinceFun"
                    >
                      <el-option
                        v-for="item in provinceOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="城市"
                    prop="cityId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.cityId"
                      filterable
                      clearable
                      placeholder="请选择城市"
                      style="width:100%"
                      @change="changeCityFun"
                    >
                      <el-option
                        v-for="item in cityOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="开始日期"
                    prop="startDate"
                  >
                    <el-date-picker
                      v-model="dialogAddEditForm.startDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="结束日期"
                    prop="endDate"
                  >
                    <el-date-picker
                      v-model="dialogAddEditForm.endDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="填报日期"
                    prop="reportDate"
                  >
                    <el-date-picker
                      v-model="dialogAddEditForm.reportDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              投放明细
              <el-button
                type="success"
                style="float:right;margin-top:1px;margin-right:10px;"
                @click="handleAdd"
              >
                选择卷烟商品
              </el-button>
            </h3>
            <div class="modal-row-box">
              <el-row
                :gutter="10"
                style="margin-bottom:10px;"
              >
                <el-col :span="24">
                  <el-table
                    :data="tobaccoListData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60"
                    />
                    <el-table-column
                      prop="tobaccoName"
                      label="名称"
                      width="150"
                    />
                    <el-table-column
                      label="投放方式"
                      width="120"
                    >
                      <template slot-scope="scope">
                        <el-select
                          v-model="scope.row.issueMethod"
                          placeholder="请选择投放方式"
                          style="width:100%"
                        >
                          <el-option
                            v-for="item in issueMethodOptions"
                            :key="item.label"
                            :label="item.label"
                            :value="item.label"
                          />
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="本周期投放量(箱)"
                      width="140"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.amount"
                          @input="(val)=>{computedMathRow(val, scope.row, 'amount')}"
                          @blur="setNumberValueDefaultZero($event, scope.row, 'amount',2)"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column label="下周期投放策略">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.tactics" />
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      width="90"
                    >
                      <template slot-scope="scope">
                        <el-button
                          type="danger"
                          size="mini"
                          @click="handleDeleteItem(scope.$index)"
                        >
                          删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              政策说明
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="description">
                    <el-input
                      v-model="dialogAddEditForm.description"
                      type="textarea"
                      placeholder="政策说明"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditForm.remark"
                      type="textarea"
                      placeholder="备注"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
    <!-- 物料列表 -->
    <tobacco-list-dialog
      :dialog-visible.sync="dialogTobaccoVisible"
      dialog-title="卷烟商品信息"
      @selectedTobaccoFun="selectedTobaccoFun"
    />
  </div>
</template>
<script>
// 数据请求
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 选择卷烟
import TobaccoListDialog from './tobaccoListDialog'
// 数据请求
import { loadAreaDataApi } from '@/api/area'
import { loadDictDataApi } from '@/api/dict'
import { saveOrUpdateIssuePolicyInfoApi, initIssuePolicyInfoApi, findIssuePolicyInfoDetailByCityIdApi } from '@/api/issuePolicyInfo'
export default {
  components: { TobaccoListDialog },
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',
      dialogAddEditForm: {
      },
      dialogAddEditFormRules: {
        // policyName: [{ required: true, message: '请输入政策名称', trigger: 'blur' },{ max: 128, message: '最多输入128个字符', trigger: 'blur' }],
        provinceId: [{ required: true, message: '请选择省区', trigger: 'change' }],
        cityId: [{ required: true, message: '请选择城市', trigger: 'change' }],
        startDate: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        endDate: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        reportDate: [{ required: true, message: '请选择填报时间', trigger: 'change' }],
        description: [{ max: 1024, message: '最多输入1024个字符', trigger: 'blur' }],
        remark: [{ max: 512, message: '最多输入512个字符', trigger: 'blur' }]
      },
      tobaccoListData: [],
      provinceOptions: [],
      cityOptions: [],
      issueMethodOptions: [],
      dialogTobaccoVisible: false
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.loading = true
        this.loadingText = '努力加载数据中，请耐心等待'
        this.operateButtonDisable = false
        this.$nextTick(() => {
          this.$refs.dialogAddEditForm.clearValidate()
        })
        this.provinceOptions = []
        this.cityOptions = []
        this.issueMethodOptions = []
        this.dialogAddEditForm = {
          provinceId: '',
          provinceName: '',
          cityId: '',
          cityName: '',
          policyName: '',
          startDate: '',
          endDate: '',
          reportDate: '',
          description: '',
          remark: ''
        }
        this.tobaccoListData = []
        this.initIssueMethodSelectData()
        this.initProvinceSelectData()
        if (this.eventType !== 'add') {
          this.initData()
        }
      }
    }
  },
  methods: {
    // 初始省区下拉数据
    initProvinceSelectData() {
      loadAreaDataApi({ parentId: 1, isUserArea: 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
        if (this.eventType === 'add') this.loading = false
      })
    },
    // 选择省区回调
    changeProvinceFun(val) {
      let selectItem = {}
      selectItem = this.provinceOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditForm.provinceName = selectItem ? selectItem.label : ''
      this.cityOptions = []
      this.dialogAddEditForm.cityName = ''
      this.dialogAddEditForm.cityId = null
      this.initCitySelectData(val)
      if (this.eventType === 'add')
        this.tobaccoListData = []
    },
    // 初始城市下拉数据
    initCitySelectData(val) {
      loadAreaDataApi({ parentId: val, isUserArea: 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.cityOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择城市回调
    changeCityFun(val) {
      let selectItem = {}
      selectItem = this.cityOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditForm.cityName = selectItem ? selectItem.label : ''
      this.tobaccoListData = []
      if (val !== null && val !== undefined && this.eventType === 'add') {
        findIssuePolicyInfoDetailByCityIdApi({ cityId: val }).then(res => {
          this.tobaccoListData = res.data
        })
      }
    },
    // 初始投放方式下拉数据
    initIssueMethodSelectData() {
      loadDictDataApi({ type: 41 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.issueMethodOptions.push({ label: item.optionLable, data: item.optionValue })
        })
      })
    },
    // 添加卷烟
    handleAdd() {
      this.dialogTobaccoVisible = !this.dialogTobaccoVisible
    },
    // 选择卷烟
    selectedTobaccoFun(selectData) {
      selectData.forEach(item => {
        let hasItem = false
        this.tobaccoListData.forEach(mItem => {
          if (mItem.tobaccoId === item.id) {
            hasItem = true
          }
        })
        if (!hasItem) {
          let pushItem = {
            tobaccoId: item.id,
            tobaccoName: item.name,
            issueMethod: this.issueMethodOptions[0].label,
            amount: 1,
            tactics: ''
          }
          this.tobaccoListData.push(pushItem)
        }
      })
    },
    // 删除物料
    handleDeleteItem(index) {
      this.tobaccoListData.splice(index, 1)
    },
    // 数字处理
    computedMathRow(val, obj, name) {
      this.limitPositiveNumber(val, obj, name)
      this.setNumberZero(obj, name)
    },
    // 加载数据
    initData() {
      initIssuePolicyInfoApi({ id: this.dataId }).then(res => {
        const { bill, detailList } = res.data
        for (let key in this.dialogAddEditForm) {
          if (key !== 'startDate' && key !== 'endDate' && key !== 'reportDate') {
            this.dialogAddEditForm[key] = bill[key]
          }
        }
        this.dialogAddEditForm.startDate = bill.startDateStr
        this.dialogAddEditForm.endDate = bill.endDateStr
        this.dialogAddEditForm.reportDate = bill.reportDateStr
        this.dialogAddEditForm.id = bill.id
        this.tobaccoListData = detailList
        this.initCitySelectData(bill.provinceId)
        this.loading = false
      })
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      this.$refs.dialogAddEditForm.validate(valid => {
        if (valid) {
          if (this.tobaccoListData.length > 0) {
            // let isHasZero = false
            // this.tobaccoListData.forEach(item => {
            //   if (Number(item.amount) === 0) {
            //     isHasZero = true
            //   }
            // })
            // if (isHasZero) {
            //   this.$message({
            //     message: '投放数量不能为0',
            //     type: 'warning'
            //   })
            //   return false
            // }
          } else {
            this.$message({
              message: '投放明细不能为空',
              type: 'warning'
            })
            return false
          }
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '投放政策', '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.operateButtonDisable = true
              this.loading = true
              this.loadingText = '正在处理数据中，请耐心等待'
              this.dialogAddEditForm.detailInfo = JSON.stringify(this.tobaccoListData)
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存
    saveOrUpdate() {
      saveOrUpdateIssuePolicyInfoApi(this.dialogAddEditForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
}
::v-deep .el-table--mini td {
  padding: 4px;
}
.pic-container {
  position: relative;
  .pic-name {
    display: inline-block;
    padding-top: 7px;
    margin-bottom: 10px;
  }
  .upload-button {
    position: absolute;
    top: 0;
    right: 0px;
  }
  ::v-deep .el-upload--picture-card i {
    font-size: 14px !important;
    color: #fff !important;
  }
  ::v-deep .el-upload--picture-card {
    border: none;
    height: 0px;
    overflow: hidden;
  }
}
::v-deep .el-upload-list--picture-card {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  .el-upload-list__item {
    display: flex;
    flex: 0 0 218px;
    margin-right: 8px;
    width: 218px;
    height: 218px;
    align-items: center;
    border-radius: 0;
  }
  .el-upload-list__item-thumbnail {
    height: auto;
    align-items: center;
  }
}
</style>
